import React from 'react';
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  DialogActions,
  Typography,
  Button,
  useTheme,
} from '@mui/material';
import propTypes from 'prop-types';
import { ReactComponent as CloseIcon } from '../../assets/CloseIcon.svg';
import DialogTransition from './DialogTransition';

const ChangeStatusDialog = ({
  open,
  onCloseClick,
  onChangeClick,
  confirmationMsg,
  dialogTitle,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      onClose={onCloseClick}
      maxWidth="xs"
      fullWidth={true}
      TransitionComponent={DialogTransition}
      open={open}
    >
      <DialogTitle>{dialogTitle || 'Change Status'}</DialogTitle>
      <IconButton
        onClick={onCloseClick}
        size="large"
        sx={{ position: 'absolute', right: 16, top: 8 }}
      >
        <CloseIcon style={{ color: theme.palette.other.icon }} />
      </IconButton>
      <DialogContent dividers sx={{ padding: '0px' }}>
        <Grid container direction="column" px={4}>
          <Grid
            item
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            paddingY={2}
            paddingX={1}
          >
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                }}
              >
                {confirmationMsg}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCloseClick}>
          No
        </Button>
        <Button variant="contained" onClick={onChangeClick}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ChangeStatusDialog.propTypes = {
  open: propTypes.bool.isRequired,
  onCloseClick: propTypes.func.isRequired,
  onChangeClick: propTypes.func.isRequired,
  confirmationMsg: propTypes.string.isRequired,
};

export default ChangeStatusDialog;
